import React from 'react';

import { BaseTouchable } from './BaseTouchable';
import {
  getHitSlop,
  ITouchableProps,
  TouchableTypeEnum,
} from './touchableCommon';

export type { ITouchableProps };
export { TouchableTypeEnum };

export function Touchable({
  children,
  hitSlop,
  ...props
}: ITouchableProps) {
  const hit = getHitSlop(hitSlop);

  return (
    <BaseTouchable {...props} hitSlop={hit}>
      {children}
    </BaseTouchable>
  );
}
